module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LS011B7DH03-11-24-17.c86d3bde.pdf";